export enum ExcelStaticResources {
  weekViewReport = 'squadrons/week-view/generate-report',
}
